import { createSlice } from "@reduxjs/toolkit";
import { AppThunk } from "./app";
import api from "./api";
import API_URL from "../config/ApiUrl";

const SIMManagementSlice = createSlice({
  name: "SIMManagement",
  initialState: {},
  reducers: {},
});
export const getSimList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(API_URL.SIM_MANAGEMENT.LIST, payload);
      return Promise.resolve(resp.data);
    } catch (e: any) {
      return Promise.reject(e.data);
    }
  };
export const deleteSimData =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.SIM_MANAGEMENT.DELETE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };

export const createSIM =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.SIM_MANAGEMENT.ADD, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const updateSIM =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.SIM_MANAGEMENT.UPDATE, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export const FixCSV =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.SIM_MANAGEMENT.FIX_CSV_INSERT, payload);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
  export const exportFormFields =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const response = await api.post(API_URL.SIM_MANAGEMENT.EXPORT_FIELDS);
      return Promise.resolve(response.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
  export const exportList =
  (payload?: any): AppThunk<any> =>
  async () => {
    try {
      const resp = await api.post(
        API_URL.SIM_MANAGEMENT.EXPORT_DATA,
        payload
      );
      return Promise.resolve(resp.data);
    } catch (error: any) {
      return Promise.reject(error.data);
    }
  };
export default SIMManagementSlice.reducer;
